import React from 'react'
import useTranslations from 'src/hooks/useTranslations'
import useUserData from 'src/hooks/useUserData'
import { faLaptopCode } from '@fortawesome/pro-regular-svg-icons/faLaptopCode'
import { faLaptopCode as faLaptopCodeSolid } from '@fortawesome/pro-solid-svg-icons/faLaptopCode'
import {
    isAllowed,
    ITP_INTEGRATION_OVERVIEW_PERMISSION,
    ITP_MANAGER_OVERVIEW_PERMISSION,
} from 'src/utils/permissions'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { reverse } from 'src/routes/config'

export default function ItpMenu({ isOpen, parentIsCollapsed, onClick }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const userData = useUserData()

    return (
        <MainMenuItem
            icon={faLaptopCode}
            iconActive={faLaptopCodeSolid}
            title={t('Integrations')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
        >
            {isAllowed(userData, ITP_INTEGRATION_OVERVIEW_PERMISSION) && (
                <MainMenuItem
                    title={t('Integration overview')}
                    to={reverse('itp', {
                        subPath: 'integration-overview',
                    })}
                    isActive={() => false}
                />
            )}
            {isAllowed(userData, ITP_MANAGER_OVERVIEW_PERMISSION) && (
                <MainMenuItem
                    title={t('Integration Admin tool')}
                    to={reverse('itp', {
                        subPath: 'manager-overview',
                    })}
                    isActive={() => false}
                />
            )}
        </MainMenuItem>
    )
}
